import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface DistributionState extends ListState<any> {
    ExpressInfo: any,
}

class Distributionimports extends ListModule<DistributionState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 50,
        list: new Array<any>(),
        loading: false,
        pageSizeOpts:[50,100,150,200]

    }
    actions = {
        async getAll(context: ActionContext<DistributionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/DistributionProduct/GetDistributionProductList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async OpreationProduct(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/DistributionProduct/OperationProduct', payload.data);
        },
        async UpdateProduct(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/DistributionProduct/UpdateProduct', payload.data);
        },

    };
    mutations = {
        setCurrentPage(state: DistributionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: DistributionState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const distributionimport = new Distributionimports();
export default distributionimport;